// extracted by mini-css-extract-plugin
export default {"controlsContainer":"paddingComponentEditorItem_controlsContainer__PpFiz","controlContainer":"paddingComponentEditorItem_controlContainer__-efr+"};